import script from "./CommunityDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityDetailView.vue?vue&type=script&setup=true&lang=js"

import "./CommunityDetailView.vue?vue&type=style&index=0&id=ff0809e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff0809e0"]])

export default __exports__